import i18n from '@/libs/i18n';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Language = 'en' | 'fr' | 'it';

interface LanguageState {
  language: Language;
  setLanguage: (lang: Language) => void;
  initializeLanguage: (userLanguage?: Language) => void;
}

const useLanguageStore = create<LanguageState>()(
  persist(
    (set, get) => ({
      language: 'en',

      setLanguage: (lang: Language) => {
        // Update i18next language
        i18n.changeLanguage(lang);

        // Update store
        set({ language: lang });
      },

      initializeLanguage: (userLanguage?: Language) => {
        const storedLanguage = get().language;
        // Priority: user preference from backend > stored preference > browser default
        const languageToUse = userLanguage || storedLanguage;

        if (languageToUse && languageToUse !== i18n.language) {
          get().setLanguage(languageToUse);
        }
      },
    }),
    {
      name: 'language-store',
      partialize: (state) => ({
        language: state.language,
      }),
    }
  )
);

export default useLanguageStore;
